/* TekiTools Tilt Card — vanilla-JS adaptation of the spell.sh tilt-card.
   Auto-applies to any element with data-teki-tilt. Read overrides via:
     data-tilt-limit="15"
     data-tilt-scale="1.05"
     data-tilt-perspective="1200"
     data-tilt-effect="evade" | "gravitate"
     data-tilt-spotlight="false"
*/
(function () {
  'use strict';

  var DEFAULTS = {
    tiltLimit: 15,
    scale: 1.05,
    perspective: 1200,
    effect: 'evade',
    spotlight: true
  };

  function isCoarseOrReducedMotion() {
    return (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(pointer: coarse)').matches
    );
  }

  function attach(el) {
    if (el.__tekiTiltAttached) return;
    el.__tekiTiltAttached = true;
    if (isCoarseOrReducedMotion()) return;

    var tiltLimit = parseFloat(el.dataset.tiltLimit) || DEFAULTS.tiltLimit;
    var scale = parseFloat(el.dataset.tiltScale) || DEFAULTS.scale;
    var perspective = parseFloat(el.dataset.tiltPerspective) || DEFAULTS.perspective;
    var effect = el.dataset.tiltEffect || DEFAULTS.effect;
    var useSpotlight = el.dataset.tiltSpotlight !== 'false' && DEFAULTS.spotlight;

    // 'evade' = card tilts AWAY from cursor (top of card pushes back when cursor is at top)
    // 'gravitate' = card tilts TOWARD cursor
    var sign = effect === 'gravitate' ? -1 : 1;

    el.style.setProperty('--tilt-perspective', perspective + 'px');
    el.style.setProperty('--tilt-rx', '0deg');
    el.style.setProperty('--tilt-ry', '0deg');
    el.style.setProperty('--tilt-scale', '1');

    var spotlightEl = null;
    if (useSpotlight) {
      spotlightEl = document.createElement('span');
      spotlightEl.className = 'teki-tilt-spotlight';
      spotlightEl.setAttribute('aria-hidden', 'true');
      // Ensure card establishes a positioned context for the spotlight
      var pos = window.getComputedStyle(el).position;
      if (pos === 'static') el.style.position = 'relative';
      el.appendChild(spotlightEl);
    }

    var rect = null;
    var rafId = 0;
    var pendingX = 0;
    var pendingY = 0;

    function refreshRect() { rect = el.getBoundingClientRect(); }

    function paint() {
      rafId = 0;
      if (!rect) return;
      var nx = (pendingX / rect.width) * 2 - 1;   // -1 .. 1
      var ny = (pendingY / rect.height) * 2 - 1;  // -1 .. 1
      var rotateY = sign * nx * tiltLimit;        // mouse to right -> card right edge tips back (evade)
      var rotateX = -sign * ny * tiltLimit;       // mouse up -> card top edge tips back (evade)
      el.style.setProperty('--tilt-rx', rotateX.toFixed(2) + 'deg');
      el.style.setProperty('--tilt-ry', rotateY.toFixed(2) + 'deg');
      el.style.setProperty('--tilt-scale', scale);
      if (spotlightEl) {
        var sx = (pendingX / rect.width) * 100;
        var sy = (pendingY / rect.height) * 100;
        spotlightEl.style.setProperty('--sx', sx.toFixed(1) + '%');
        spotlightEl.style.setProperty('--sy', sy.toFixed(1) + '%');
      }
    }

    function onPointerEnter(e) {
      if (e.pointerType === 'touch') return;
      refreshRect();
      el.classList.add('teki-tilt-active');
    }
    function onPointerMove(e) {
      if (e.pointerType === 'touch') return;
      if (!rect) refreshRect();
      pendingX = e.clientX - rect.left;
      pendingY = e.clientY - rect.top;
      if (!rafId) rafId = requestAnimationFrame(paint);
    }
    function onPointerLeave(e) {
      if (e.pointerType === 'touch') return;
      el.classList.remove('teki-tilt-active');
      if (rafId) { cancelAnimationFrame(rafId); rafId = 0; }
      el.style.setProperty('--tilt-rx', '0deg');
      el.style.setProperty('--tilt-ry', '0deg');
      el.style.setProperty('--tilt-scale', '1');
    }

    el.addEventListener('pointerenter', onPointerEnter);
    el.addEventListener('pointermove', onPointerMove);
    el.addEventListener('pointerleave', onPointerLeave);
    window.addEventListener('resize', function () { rect = null; }, { passive: true });
    window.addEventListener('scroll', function () { rect = null; }, { passive: true });
  }

  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('[data-teki-tilt]');
    for (var i = 0; i < nodes.length; i++) attach(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init when sections reload in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
